import PropTypes from "prop-types";
import FormLabel from "./FormLabel";
import React from "react";

const RadioGroup = ({label, children, isRequired, className = ""}) => {
  return (
    <div className={className}>
      <FormLabel label={label} isRequired={isRequired}/>
      <div className="flex space-x-5"> {children} </div>
    </div>);
};
const RadioItem = ({
                     name,
                     value,
                     label = "radioItem",
                     isChecked,
                     onChanged,
                     className,
                     radioClassName = "w-4 h-4",
                     disabled = false,
                     showRadioButton = true
                   }) => {
  return (
    <label className={`flex items-center ${className ? className : ""}`}> {showRadioButton &&
      <input disabled={disabled} className={radioClassName} type="radio" name={name} value={value} checked={isChecked}
             onChange={(_ => onChanged())}/>}
      <span className={`${disabled ? "text-disabled" : "text-dark"} ml-3`}>{label}</span>
    </label>
  );
};
RadioItem.propTypes = {
  value: PropTypes.string.isRequired,
  isChecked: PropTypes.bool.isRequired,
  onChanged: PropTypes.func.isRequired
};
export {RadioGroup, RadioItem};
